export default {
  logosNumber: 5,
  smallLogos: false
};
